import HeadTittle from '../../../../../components/HeadTittle';
import React from 'react';
import DivContainerBody from '../../../../../components/DivContainerBody';
import VehicleDetailsDocumentationApp from '../../Functionality/VehicleDetailsFlows/VehicleDetailsDocumentationApp';
import VehicleDetailsCard from './VehicleDetailsCard';
import CustomExpandableTable from '../../../../../components/table/CustomExpandableTable';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const VehicleDetailsDocumentation = (
    {
        userType
    }
) => {


    const {
        t,
        tableId,
        elementDetails,
        handleRowExpand,
        columns,
        sections,
        renderExpandedRow,
        goBack
    } = VehicleDetailsDocumentationApp({userType});

    return (
        <>
            <HeadTittle name={t('details')} onBack={goBack} />
            <DivContainerBody>
                <div className='row px-0 pb-5'>
                    <div className='col-sm-12 col-md-4 col-lg-3 px-0 mb-sm-3'>
                        <VehicleDetailsCard elementDetails={elementDetails} />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-9 px-0'>
                        {/**Done*/}
                        <CustomExpandableTable
                            id={tableId}
                            columns={columns}
                            rows={sections}
                            checkbox={false}
                            rowsPerPage={sections.length}
                            selectedList={[]}
                            handleCheckboxChange={() => { }}
                            handleDeleteAll={() => { }}
                            renderExpandedRow={renderExpandedRow}
                            renderOptionsMenu={null}
                            onRowExpand={handleRowExpand}
                            tooltip={false}
                            showHeader={false}
                            withoutHeight={true}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
}

export default VehicleDetailsDocumentation
